import { ListReviewAndPublishMode } from '®shared/config';
import { ContainerModes } from '®shared/container-structure';
import {
  Permissions,
  UserPermissions,
  hasPermissionForListId,
} from '®shared/permissions';
import { EditableList, ReadingListDetails } from '®shared/reading-list';

export function showPublishButton(
  containerMode: ContainerModes,
  list: ReadingListDetails,
  editableList: EditableList,
  reviewWorkflow: ListReviewAndPublishMode,
  queueHasPublishAction: boolean,
  currentUserPermissions: UserPermissions,
): boolean {
  if (!isEditMode(containerMode)) {
    return false;
  }

  return (
    (!list.is_archived &&
      editableList &&
      canPublish(editableList, currentUserPermissions) &&
      (isReviewer(editableList, currentUserPermissions) ||
        reviewWorkflow !== ListReviewAndPublishMode.REVIEW_ONLY)) ||
    queueHasPublishAction
  );
}

export function showRequestReviewButton(
  containerMode: ContainerModes,
  editableList: EditableList,
  currentUserPermissions: UserPermissions,
  reviewWorkflow: ListReviewAndPublishMode,
): boolean {
  if (!isEditMode(containerMode)) {
    return false;
  }

  return (
    canRequestReview(editableList, currentUserPermissions) &&
    !isReviewer(editableList, currentUserPermissions) &&
    !hasActiveReview(editableList) &&
    (reviewWorkflow === ListReviewAndPublishMode.REVIEW_ONLY ||
      !canPublish(editableList, currentUserPermissions)) &&
    editableList.hasUnpublishedChanges
  );
}

export function showReviewAndPublishButton(
  containerMode: ContainerModes,
  editableList: EditableList,
  currentUserPermissions: UserPermissions,
  reviewWorkflow: ListReviewAndPublishMode,
): boolean {
  if (!isEditMode(containerMode)) {
    return false;
  }

  return (
    canRequestReview(editableList, currentUserPermissions) &&
    canPublish(editableList, currentUserPermissions) &&
    reviewWorkflow === ListReviewAndPublishMode.PUBLISH_WITH_REVIEW_REMINDER &&
    !hasActiveReview(editableList) &&
    !isReviewer(editableList, currentUserPermissions) &&
    editableList.hasUnpublishedChanges
  );
}

function isEditMode(containerMode: ContainerModes): boolean {
  return containerMode === ContainerModes.Edit;
}

function isReviewer(
  editableList: EditableList,
  currentUserPermissions: UserPermissions,
): boolean {
  return hasPermissionForListId(
    Permissions.VIEW_ACQUISITIONS,
    editableList.id,
    currentUserPermissions,
  );
}

function canPublish(
  editableList: EditableList,
  currentUserPermissions: UserPermissions,
): boolean {
  return hasPermissionForListId(
    Permissions.PUBLISH_LIST,
    editableList.id,
    currentUserPermissions,
  );
}

function canRequestReview(
  editableList: EditableList,
  currentUserPermissions: UserPermissions,
): boolean {
  return hasPermissionForListId(
    Permissions.REQUEST_REVIEW,
    editableList.id,
    currentUserPermissions,
  );
}

function hasActiveReview(editableList: EditableList): boolean {
  return editableList && editableList.activeReviewUrl ? true : false;
}
